import { useEffect, useState } from "react";
import { Globe2, ExternalLink } from "lucide-react";
import { api } from "@/lib/api";

export function RemittancePartners() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/remittance/partners").then((r) => setData(r.data)).catch(() => {});
  }, []);

  const open = async (p) => {
    let link = p.link;
    try {
      const r = await api.post("/remittance/track", { partner_id: p.id });
      link = r.data.link;
    } catch (e) { /* tracking optional */ }
    window.open(link, "_blank", "noopener");
  };

  if (!data) return null;

  return (
    <div className="mt-10 rounded-2xl border border-border bg-card p-6" data-testid="remittance-partners">
      <div className="flex items-center gap-2">
        <Globe2 className="h-5 w-5 text-sky-400" />
        <h2 className="font-display text-xl">Send money home — trusted partners</h2>
      </div>
      <p className="mt-1.5 text-sm text-muted-foreground">
        Compare authorised transfer partners for UK → Nigeria and other corridors. Transfers happen with the partner, under their terms.
      </p>
      <div className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {data.partners.map((p) => (
          <button key={p.id} onClick={() => open(p)}
            className="group rounded-xl border border-border bg-background p-4 text-left transition-colors hover:border-sky-400/50"
            data-testid={`remit-partner-${p.id}`}>
            <div className="flex items-center justify-between">
              <p className="font-semibold">{p.name}</p>
              <ExternalLink className="h-3.5 w-3.5 text-muted-foreground group-hover:text-sky-400" />
            </div>
            <p className="mt-1 text-[11px] text-sky-400">{p.corridors[0]}{p.corridors.length > 1 ? ` +${p.corridors.length - 1} more` : ""}</p>
            <p className="mt-1.5 text-xs text-muted-foreground">{p.note}</p>
          </button>
        ))}
      </div>
      <p className="mt-3 text-[10px] text-muted-foreground" data-testid="remittance-disclosure">{data.disclosure}</p>
    </div>
  );
}
